import { ItemEntity } from '@entities/Item/Types';
import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';
import { CustomProjectModel } from '@entities/CustomProject/CustomProjectModel';
import { ProjectOrderedQtyPayload } from '../../../Processes/Gateways/CustomProjects/Interfaces/ProjectItemOrderedQtyPayload';

export const CreateOrderedQtyPayloadForSelectedItems = (
    selectedItems: ItemEntity[],
    parsedFragments: ParsedFragmentEntity[],
    customProject: CustomProjectModel
): ProjectOrderedQtyPayload[] => {
    return selectedItems
        .map(item => {
            const fragment = parsedFragments.find(fragment =>
                fragment.itemTypes.some(itemType =>
                    itemType.items?.some(i => i.id === item.id)
                )
            );

            if (!fragment) return null;

            const itemType = fragment.itemTypes.find(itemType =>
                itemType.items?.some(i => i.id === item.id)
            );

            if (!itemType) return null;

            return {
                item_id: item.id,
                ordered_qty: item.qty ?? 0,
                fragment_id: fragment.id,
                fragment_index: fragment.index,
                item_type_id: itemType.id,
                item_type_index: itemType.index ?? 0,
                template_id: customProject.templates?.[0].id ?? 0,
                template_index: 0,
            };
        })
        .filter(
            (payload): payload is ProjectOrderedQtyPayload => payload !== null
        );
};
